import script from "./CreateApiKey.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateApiKey.vue?vue&type=script&setup=true&lang=js"

import "./CreateApiKey.vue?vue&type=style&index=0&id=e36f069a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e36f069a"]])

export default __exports__